import { RcClasses } from '../../../../foundation';
export var RcFormControlLabelClasses = RcClasses(['root', 'disabled', 'labelPlacementStart'], 'RcFormControlLabel');
